import React from 'react';
import FAutoCombo from './FAutoCombo';
import { AutoComboWrapperProps } from './autoCombo.models';

class AutoCodeCombo extends React.PureComponent<AutoComboWrapperProps> {
  render() {
    return <FAutoCombo {...this.props} valueMode="code" />;
  }
}

export default AutoCodeCombo;
